import { mapState } from "vuex";

const SiteSettings = {
  created() {
    this.fetchSites();
  },
  methods: {
    fetchSites() {
      this.$store.dispatch("siteSettings/fetchSiteInfo");
    },
  },
  computed: {
    ...mapState("siteSettings", ["site_info"]),
  },
};

export default SiteSettings;
